import { marked } from "marked";

const rgx = /\$\$[\s\S]*\$\$|^\s*\\\[\s*([\s\S]*?)\s*\]/gm;

function mathsExpression(expr) {

    return expr.replace(rgx, (match) => {
        return `<span class="math">${match}</span>`
    });
}


export function renderMarkdown(markdown) {
    markdown = mathsExpression(markdown);
    return marked(markdown);
}